import { useNavigate } from 'react-router-dom';

function IphoneProductCard({
  id,
  image,
  name,
  storage,
  price,
  color,
  type,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === 'oneplus') {
      navigate(`/oneplusstore/products-list/product-detail/${type}/${id}`);
    } else {
      navigate(`/applestore/iphone-products-list/iphone-detail-page/${type}/${id}`);
    }
  };

  return (
    <div
      className="card"
      onClick={handleClick}
    >
      <div className="card-image">
        <img src={image} alt={name} />
      </div>
      <div className="card-content">
        <h2 className="card-title">{name}</h2>
        {/* <h2 className="card-storage">Storage : {storage}</h2> */}
        <p className="card-price">&#8377; {price}</p>
        {/* <p className="card-color">
          Color: <span className="color-name">{color[0]}</span>
        </p> */}
        <button className="card-button">View Product</button>
      </div>
    </div>
  );
}

export default IphoneProductCard;
